import { render, staticRenderFns } from "./CartInfoCard.vue?vue&type=template&id=2a874ab4&scoped=true"
import script from "./CartInfoCard.vue?vue&type=script&lang=js"
export * from "./CartInfoCard.vue?vue&type=script&lang=js"
import style0 from "./CartInfoCard.vue?vue&type=style&index=0&id=2a874ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a874ab4",
  null
  
)

export default component.exports